/**
 * Live bike list for every bike finder (Make > Model > Year), read from
 * Content > Metaobjects > Bike Data via templates/collection.bike-feed.liquid.
 *
 * - window.bikes keeps the finder shape: [{ make, models: [{ model, years: ['2024', ...] }] }]
 * - Cached list is used instantly; refreshed in the background when older than 60 seconds.
 * - Finders queue through window.mpsOnBikes(fn) (stub in snippets/all-bikes.liquid).
 */
(function () {
  if (window.mpsBikeLoader) return;
  window.mpsBikeLoader = true;

  var CACHE_KEY = 'mps_bike_data_v1';
  var FRESH_FOR = 60 * 1000;
  var KEEP_FOR = 7 * 24 * 60 * 60 * 1000;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var feedUrl = root.replace(/\/?$/, '/') + 'collections/all?view=bike-feed';

  var store = Array.isArray(window.bikes) ? window.bikes : (window.bikes = []);
  var queue = window.mpsBikeQueue || [];

  function fill(data) {
    store.length = 0;
    Array.prototype.push.apply(store, data);
  }

  function finish(data) {
    fill(data);
    if (window.mpsBikesReady) return;
    window.mpsBikesReady = true;
    queue.splice(0).forEach(function (fn) {
      try { fn(store); } catch (error) { console.error(error); }
    });
    document.dispatchEvent(new CustomEvent('bikes:ready', { detail: store }));
  }

  function build(rows) {
    var makes = {};
    rows.forEach(function (row) {
      if (!row || !row[0] || !row[1]) return;
      var make = makes[row[0]] || (makes[row[0]] = {});
      var years = make[row[1]] || (make[row[1]] = {});
      (row[2] || []).forEach(function (year) { years[String(year)] = true; });
    });
    var byName = function (a, b) { return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }); };
    return Object.keys(makes).sort(byName).map(function (make) {
      return {
        make: make,
        models: Object.keys(makes[make]).sort(byName).map(function (model) {
          return { model: model, years: Object.keys(makes[make][model]).sort() };
        })
      };
    });
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Bike feed ' + response.status);
      return response.json();
    });
  }

  function loadLive() {
    return getJSON(feedUrl).then(function (first) {
      var requests = [];
      for (var page = 2; page <= (first.pages || 1); page++) {
        requests.push(getJSON(feedUrl + '&' + encodeURIComponent(first.param || 'page') + '=' + page));
      }
      return Promise.all(requests).then(function (rest) {
        var rows = [];
        [first].concat(rest).forEach(function (part) { rows = rows.concat(part.rows || []); });
        var data = build(rows);
        if (!data.length) throw new Error('Bike feed empty');
        try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: data })); } catch (error) {}
        return data;
      });
    });
  }

  var cached = null;
  try { cached = JSON.parse(localStorage.getItem(CACHE_KEY)); } catch (error) {}
  var age = cached && cached.t && cached.d && cached.d.length ? Date.now() - cached.t : Infinity;

  if (age < KEEP_FOR) {
    finish(cached.d);
    if (age > FRESH_FOR) loadLive().then(fill).catch(function () {});
  } else {
    loadLive().then(finish).catch(function (error) {
      console.error(error);
      finish([]);
    });
  }
})();
